import { createStorage } from '@core/base/storage'
import { envVars } from '@core/environment/env-vars'
import { $eventBus } from '@core/event-bus'
import { atom } from 'nanostores'

const state = {
    accountId: atom<string | undefined>(''),
    features: atom<TFeatureFlags | object>({}),
    error: atom<boolean>(false),
    storageInstance: createStorage(),
}

export class Base {
    public name: string

    constructor(name: string) {
        this.name = name
    }

    get envVars() {
        return envVars
    }

    get $eventBus() {
        return $eventBus
    }

    get storage() {
        return state.storageInstance
    }

    get accountId(): string {
        return state.accountId.get() as string
    }

    set accountId(accountId: string) {
        state.accountId.set(accountId)
    }

    get features() {
        return state.features.get() as TFeatureFlags
    }

    set features(features: TFeatureFlags) {
        state.features.set(features)
    }

    public log(...args: unknown[]) {
        import.meta.env.REACT_APP_ENV !== 'production' &&
            console.log(`[ ${this.name} ]`, ...args)
    }
}
